module.exports = __webpack_public_path__ + "media/images/march8/march8-template-ro-4603691fe39a5cc8aa6c4a110075ac7c.png";